
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

export default {
    setup() {
        const store = useStore();
        const follow = store.state.follow;
        const loginUser = JSON.parse(localStorage.loginUser);
        const UserGUID = loginUser.UserGUID;
        const router = useRoute();
        const AnotherUserGUID = router.params.UserGUID;

        onMounted(() => {
            store.dispatch('follow/GET_FOLLOWED_USER_INFO', { UserGUID, AnotherUserGUID });
        });

        const loading = computed(() => follow.loadingUserInfo);
        const userInfo = computed(() => follow.followUserInfo);
        const followState = computed(() => follow.followState);

        const click = (type: number) => {
            const action = type === 1 ? 'follow/AGREE_FOLLOWED' : 'follow/REFUSE_FOLLOWED';
            store.dispatch(action, { UserGUID, AnotherUserGUID });
        };

        return {
            loading,
            userInfo,
            click,
            followState,
        };
    },
};
